// Run this example by adding <%= javascript_pack_tag 'hello_react' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. All it does is render <div>Hello React</div> at the bottom
// of the page.
import React from 'react'
import ReactDOM from 'react-dom'
import App from "../src/projects_module/components";
import {BrowserRouter,MemoryRouter} from 'react-router-dom';
import RootProvider from '../src/projects_module/RootProvider';


var loadNewProjectsApp = function() {
  /** @ts-ignore */
  $(document).ready(function () {
      console.log("inside loadApp method...");
    ReactDOM.render(
      <RootProvider>
        <MemoryRouter>
        <App />
        </MemoryRouter>
      </RootProvider>,
    document.querySelector(".ph-recd")
    )
  });
}
{/** @ts-ignore */}
photoOrg.authInfoCallBack = loadNewProjectsApp;   

